// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <router-link v-if="isCreateLink" to="/p/observations/create_from_selection">
    <v-card tile color="green" style="cursor: pointer; width: 90%; margin-left: 5%; height: 130px; margin-top: 7px" hover class="elevation-16">
      <v-card-text class="text-center" style="padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;">
        <div>Click to add</div>
        <v-btn fab class="green" to="/p/observations/create_from_selection" style="">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; margin-top: 6px;">{{ obsName }}</div>
      </v-card-text>
    </v-card>
  </router-link>
  <v-card v-else color="secondary" flat tile @click.capture="thumbClicked()" style="cursor: pointer; height: 144px;" hover>
    <v-card-text class="text-center" style="padding-left: 0px; padding-right: 0px; padding-bottom: 5px;">
      <img :src="obsIcon(obsData)" height="70px" style="min-height: 70px"></img>
      <div class="text-center" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ obsName }}</div>
      <div><img :src="instIcon(obsData)" height="20px" style="padding-right: 10px"></img><span v-html="ratingHtml(obsData)"></span></div>
    </v-card-text>
  </v-card>
</template>

<script>
import NoctuaSkyClient from '../../noctuasky-client'
import swh from '@/assets/sw_helpers.js'

export default {
  props: ['obsData'],
  data: function () {
    return {
    }
  },
  computed: {
    obsName: function () {
      return this.obsData.title ? this.obsData.title : swh.nameForSkySource(this.obsData.target)
    },
    isCreateLink: function () {
      return this.obsData.id === 'pseudo_obs_selection'
    }
  },
  methods: {
    instIcon: function (obsData) {
      return NoctuaSkyClient.iconForObservingSetup(obsData.observing_setup)
    },
    obsIcon: function (obsData) {
      return swh.iconForObservation(obsData)
    },
    ratingHtml: function (obsData) {
      const imgStarRate = require('../../assets/images/ui/star_rate.svg')
      const imgStarBorder = require('../../assets/images/ui/star_border.svg')
      var res = ('<img src="' + imgStarRate + '" height="15px"></img>').repeat(obsData.rating)
      res += ('<img src="' + imgStarBorder + '"  height="15px" style="opacity: 0.1;"></img>').repeat(5 - obsData.rating)
      return res
    },
    thumbClicked: function () {
      this.$emit('thumbClicked')
    }
  }
}
</script>

<style>
</style>
